import React from 'react'
import foto from '../../Imagenes/Logo.png'
import foto1 from "../../Imagenes/logo 3.0.png";
const Logo = () => {
  return (
    <div><img src={foto1} alt ="logo" width="50px" height="50px"/></div>
  )
}

export default Logo